import axios from "@/interceptor";
import merge from "lodash/merge";

class User {
  constructor() {
    this.id = 0;
    this.username = "";
    this.userdesc = "";
		this.password = "";
		this.is_oa_user = true;
		this.email = "";
		this.mobile = "";
		this.department = "";
		this.company = "";
    this.active = true;
    this.type = "";
    this.update_time = new Date();
    this.create_time = new Date();
  }

  static getCurrentUser() {
    const url = process.env.VUE_APP_API_URL + "api/v1/user/self";
    return axios.get(url).then((res) => {
      let user = new User();
      user = Object.assign(user, res.data.user);
      return user;
    });
  }

  static getAllUsers() {
    const url = process.env.VUE_APP_API_URL + "api/v1/users";
    return axios.get(url, { params: { per_page: "all" } }).then((res) => {
      let users = new Array();
      for (const item of res.data.results) {
        let user = new User();
        user = Object.assign(user, item);
        users.push(user);
      }
      returndata.total = res.data.total
      return users;
    });
	}
  static getUsers(filters) {
    const url = process.env.VUE_APP_API_URL + "api/v1/users";
    if (!filters.per_page || filters.per_page == '') {
      filters.per_page = -1
    }
    console.log(filters)
    return axios.get(url, { params:filters }).then((res) => {
      let returndata = {}
      returndata.users =  new Array();
      for (const item of res.data.results) {
        let user = new User();
        user = Object.assign(user, item);
        returndata.users.push(user);
      }
      returndata.total = res.data.total
      return returndata;
    });
	}
	
	static getUserByName(username) {
    const url = process.env.VUE_APP_API_URL + "api/v1/users";
    return axios.get(url, { params: { username: username } }).then((res) => {
      let user = new User();
      user = Object.assign(user, res.data.results[0]);
      return user;
    });
  }

	static register(data) {
    const url = process.env.VUE_APP_API_URL + "auth/register";
    return axios.post(url, data).then((res) => {
			console.log(res)
      return res;
    });
  }
}
class Role {
  constructor() {
    this.id = "";
    this.rolename = "";
    this.rolecode = "";
    this.create_time = "";
    this.update_time = "";
    this.users = [];
  }
  static getUserRoles() {
    const url = process.env.VUE_APP_API_URL + "api/v1/roles/self";
    return axios.get(url).then((res) => {
      let returndata = {}
            returndata.result = []
            let c = new Role()
            res.data.results.forEach((x) => {
              let c = new Role()
              Object.assign(c, x)
              returndata.result.push(c)
          })
          returndata.total = res.data.total
          return returndata
    });
  }
  static getRoles() {
    const url = process.env.VUE_APP_API_URL + "api/v1/roles";
    return axios.get(url).then((res) => {
      let returndata = {}
            returndata.result = []
            let c = new Role()
            res.data.results.forEach((x) => {
              let c = new Role()
              Object.assign(c, x)
              returndata.result.push(c)
          })
          returndata.total = res.data.total
          return returndata
    });
  }
  static addUsers(id,user) {
    const url = process.env.VUE_APP_API_URL + "api/v1/raddu?id="+id+"";
    //修改
    const data = merge({}, user);

    return axios
      .put(url, data)
      .then((res) => {
        let result = new Role();
        result = merge(result, res.data.item);
        return result;
      });

  }
  static deleteUser(id,user) {
    const url = process.env.VUE_APP_API_URL + "api/v1/rdeleteu?id="+id+"";
    //修改
    const data = merge({}, user);

    return axios
      .put(url, data)
      .then((res) => {
        let result = new Role();
        result = merge(result, res.data.item);
        return result;
      });

  }



}

export default User;
export { User, Role };
